<template>
  <div>
    <el-row>
      <el-col :span="6" v-if="canEdit">
        <div class="left-box">
          <div class="flex-fs item" draggable="true" @dragend="drag($event, 'text')" @click="drag($event, 'text')">
            <i class="el-icon-edit"></i>
            <span>输入框</span>
          </div>
          <div class="flex-fs item" draggable="true" @dragend="drag($event, 'image')" @click="drag($event, 'image')">
            <i class="el-icon-picture"></i>
            <span>图片</span>
          </div>
          <div class="flex-fs item" draggable="true" @dragend="drag($event, 'select')" @click="drag($event, 'select')">
            <i class="el-icon-caret-bottom"></i>
            <span>下拉选项</span>
          </div>
          <div class="flex-fs item" draggable="true" @dragend="drag($event, 'file')" @click="drag($event, 'file')">
            <i class="el-icon-paperclip"></i>
            <span>上传附件</span>
          </div>
          <div class="flex-fs item" draggable="true" @dragend="drag($event, 'radio')" @click="drag($event, 'radio')">
            <i class="el-icon-circle-check"></i>
            <span>单项选择</span>
          </div>
          <div class="flex-fs item" draggable="true" @dragend="drag($event, 'checkbox')" @click="drag($event, 'checkbox')">
            <i class="el-icon-finished"></i>
            <span>复选框</span>
          </div>
          <div class="flex-fs item" draggable="true" @dragend="drag($event, 'textarea')" @click="drag($event, 'textarea')">
            <i class="el-icon-edit-outline"></i>
            <span>文本域</span>
          </div>
        </div>
      </el-col>
      <el-col :span="10" :offset='1'>
        <div class="right-box">
          <draggable v-model="formList" animation="600" v-if="formList.length">
            <transition-group>
                <div class="item" v-for="(element,i) in formList" :key="i">
                  <!-- text:文本输入框,radio:单选输入框,select:下拉列表框,textarea:文本区域,checkbox:复选输入框,image:图片,file:附件 -->
                  <div class="type-input" v-if="element.config_type == 'text'">
                    <div>
                      <input class="title" type="text" placeholder="请输入标题" v-model="element.title" :disabled='element.isDefault === true || !canEdit'>
                    </div>
                    <div>
                      <input class="val" type="text" disabled>
                    </div>
                    <div>
                      <el-checkbox v-model="element.is_require" :disabled='element.isDefault === true || !canEdit'>必填项</el-checkbox>
                    </div>
                    <i class="el-icon-delete" @click="formList.splice(i,1)" v-if="element.isDefault !== true && canEdit"></i>
                  </div>
                  
                  <div class="type-input" v-if="element.config_type == 'textarea'">
                    <div>
                      <input class="title" type="text" placeholder="请输入标题" v-model="element.title" :disabled='!canEdit'>
                    </div>
                    <div>
                      <input class="val" type="text" disabled style="height: 150px;width: 300px;">
                    </div>
                    <div>
                      <el-checkbox v-model="element.is_require" :disabled='!canEdit'>必填项</el-checkbox>
                    </div>
                    <i class="el-icon-delete" @click="formList.splice(i,1)" v-if="canEdit"></i>
                  </div>
                  
                  <div class="type-input" v-if="element.config_type =='radio'">
                    <input class="title" type="text" placeholder="请输入标题" v-model="element.title" :disabled='element.isDefault === true || !canEdit'>
                    <div v-for="(o,i2) in element.option" :key="i2" class="flex-fs" style="margin-bottom: 12px;">
                      <span class="MY-radio"></span>
                      <input class="optionInput" type="text" v-model="o.value" placeholder="请输入选项名称" @input="o.label=o.value" :disabled='element.isDefault === true'>
                      <i class="el-icon-delete el-icon-delete-1" @click="element.option.splice(i2,1)" v-if="element.isDefault !== true && canEdit"></i>
                    </div>
                    <div style="margin-bottom: 15px;" v-if="element.isDefault !== true && canEdit">
                      <el-button type="text" @click="element.option.push({
                        value: '选项名称',
                        label: '选项名称'
                      })">+ 添加选项</el-button>
                    </div>  
                   <div>
                      <el-checkbox v-model="element.is_require" :disabled='element.isDefault === true || !canEdit'>必填项</el-checkbox>
                   </div>
                    <i class="el-icon-delete" @click="formList.splice(i,1)" v-if="element.isDefault !== true && canEdit"></i>
                  </div>
                  
                  <div class="type-input" v-if="element.config_type =='select'">
                    <input class="title" type="text" placeholder="请输入标题" v-model="element.title" :disabled='!canEdit'>
                    <div v-for="(o,i2) in element.option" :key="i2" class="flex-fs" style="margin-bottom: 12px;">
                      <input class="optionInput" type="text" v-model="o.value" placeholder="请输入选项名称" @input="o.label=o.value">
                      <i class="el-icon-delete el-icon-delete-1" @click="element.option.splice(i2,1)" v-if="canEdit"></i>
                    </div>
                    <div style="margin-bottom: 15px;" v-if="canEdit">
                      <el-button type="text" @click="element.option.push({
                        value: '选项名称',
                        label: '选项名称'
                      })">+ 添加选项</el-button>
                    </div>
                    <div>
                       <el-checkbox v-model="element.is_require" :disabled='!canEdit'>必填项</el-checkbox>
                    </div>
                    <i class="el-icon-delete" @click="formList.splice(i,1)" v-if="canEdit"></i>
                  </div>
                  
                  
                  <div class="type-input" v-if="element.config_type =='checkbox'">
                    <input class="title" type="text" placeholder="请输入标题" v-model="element.title" :disabled='!canEdit'>
                    <div v-for="(o,i2) in element.option" :key="i2" class="flex-fs" style="margin-bottom: 12px;">
                      <span class="MY-checkbox"></span>
                      <input class="optionInput" type="text" v-model="o.value" placeholder="请输入选项名称" @input="o.label=o.value">
                      <i class="el-icon-delete el-icon-delete-1" @click="element.option.splice(i2,1)" v-if="canEdit"></i>
                    </div>
                    <div style="margin-bottom: 15px;" v-if="canEdit">
                      <el-button type="text" @click="element.option.push({
                        value: '选项名称',
                        label: '选项名称'
                      })">+ 添加选项</el-button>
                    </div>
                    <div>
                       <el-checkbox v-model="element.is_require" :disabled='!canEdit'>必填项</el-checkbox>
                    </div>
                    <i class="el-icon-delete" @click="formList.splice(i,1)" v-if="canEdit"></i>
                  </div>
                  
                  <div class="type-input" v-if="element.config_type == 'image'">
                    <input class="title" type="text" placeholder="请输入标题" v-model="element.title" :disabled='!canEdit'>
                    <div class="flex-ct MY-image">
                      <i class="el-icon-picture"></i>
                    </div>
                    <div>
                       <el-checkbox v-model="element.is_require" :disabled='!canEdit'>必填项</el-checkbox>
                    </div>
                    <i class="el-icon-delete" @click="formList.splice(i,1)" v-if="canEdit"></i>
                  </div>
                  
                  <div class="type-input" v-if="element.config_type == 'file'">
                    <input class="title" type="text" placeholder="请输入标题" v-model="element.title" :disabled='!canEdit'>
                    <div class="flex-ct MY-image">
                      <i class="el-icon-paperclip"></i>
                    </div>
                    <div>
                       <el-checkbox v-model="element.is_require" :disabled='!canEdit'>必填项</el-checkbox>
                    </div>
                    <i class="el-icon-delete" @click="formList.splice(i,1)" v-if="canEdit"></i>
                  </div>
                </div>
            </transition-group>
          </draggable>
          <div v-else style="text-align: center;line-height: 450px;color: #999;">请选择表单项</div>
        </div>
      </el-col>
    </el-row>
    <div class="flex-fs" style="padding: 30px 0;">
      <el-button @click="$router.back()">取 消</el-button>
      <el-button type="primary" @click="save">确 定</el-button>
    </div>
   </div>
</template>

<script>
  import draggable from 'vuedraggable'
  
  export default{
    components:{ draggable },
    props: {
      canEdit: {
        type: Boolean,
        default: true
      }
    },
    created() {
 
    },
    data() {
      return {
        formList: [
          {title: '姓名', config_type: 'text', is_require: true, option: [], is_multivalue: false, isDefault: true},
          {title: '性别', config_type: 'radio', is_require: true, option: [{label: '男',value: '男'},{label: '女',value: '女'}], is_multivalue: false, isDefault: true},
          {title: '手机号', config_type: 'text', is_require: true, option: [], is_multivalue: false, isDefault: true},
          {title: '身份证号', config_type: 'text', is_require: true, option: [], is_multivalue: false, isDefault: false},
          {title: '工作经历', config_type: 'textarea', is_require: true, option: [], is_multivalue: false, isDefault: false},
          {title: '是否党员', config_type: 'radio', is_require: true, option: [{label: '是',value: '是'},{label: '否',value: '否'}], is_multivalue: false, isDefault: false},
          // {title: '文本输入框', config_type: 'text', is_require: true, option: [], is_multivalue: false},
          // {title: '下拉列表', config_type: 'select', is_require: true, option: [{label: '下拉1',value: '下拉'},{label: '下拉2',value: '下拉2'}], is_multivalue: false},
          // {title: '单选', config_type: 'radio', is_require: true, option: [{label: '单选1',value: '单选1'},{label: '单选2',value: '单选2'}], is_multivalue: false},
          // {title: '文本区域', config_type: 'textarea', is_require: true, option: [], is_multivalue: false},
          // {title: '复选', config_type: 'checkbox', is_require: true, option: [{label: '复选1',value: '复选1'},{label: '复选2',value: '复选2'}], is_multivalue: false},
          // {title: '图片', config_type: 'image', is_require: true, option: [], is_multivalue: false},
          // {title: '附件', config_type: 'file', is_require: true, option: [], is_multivalue: false}
        ]
      }
    },
    methods:{
        drag(ev, type) {
          let is_multivalue = false
          if(type == 'image' || type == 'checkbox' || type == 'file'){
            is_multivalue = true
          }
          this.formList.push({title: '', config_type: type, is_require: false, option: [], is_multivalue: is_multivalue})
        },
        // 允许放下拖拽
        allowDrop(ev) {
          console.log(ev)
          
          ev.preventDefault();
        },
        // 放下事件
        drop(ev, item) {
          console.log("放下", item);
          console.log(ev);
          ev.preventDefault();
          let treeNode = ev.target;
          if (treeNode) {
            treeNode.appendChild(this.dom);
          }
        },  
      save(){
        if(!this.canEdit){ // 编辑
          this.$emit('change',this.formList)
        }else{
          
          if(!this.formList.length){
            this.$message.warning('表单项不能为空！')
            return
          }
          
          if(this.formList.find(i=>!i.title)){
            this.$message.warning('表单项标题不能为空！')
            return
          }
          if(this.formList.find(i=>i.config_type == 'select' && (!i.option.length || i.option.find(k=>!k.value)))){
            this.$message.warning('下拉列表选项不能为空！')
            return
          }
          if(this.formList.find(i=>i.config_type == 'radio' && (!i.option.length || i.option.find(k=>!k.value)))){
            this.$message.warning('单选选项不能为空！')
            return
          }
          if(this.formList.find(i=>i.config_type == 'checkbox' && (!i.option.length || i.option.find(k=>!k.value)))){
            this.$message.warning('复选选项不能为空！')
            return
          }
          let list = this.formList.filter(i=>i.isDefault !== true).map(k=>{
            delete k.isDefault
            return k
          })
          this.$emit('change',list)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .left-box{
    border: 1px solid #eee;
    min-height: 450px;
    padding: 20px;
    .item{
      border: 1px solid #eee;
      height: 52px;
      padding: 0 10px;
      margin-bottom: 20px;
      cursor: grab;
      border-radius: 2px;
      i{
        color: #999;
        font-size: 22px;
        margin-right: 10px;
      }
      span{
        font-size: #666;
      }
    }
  }
  .right-box{
    border: 1px solid #eee;
    min-height: 550px;
    // .chosen{
    //   background-color: #f2f2f2;
    // }
    .el-icon-delete{
      color: red;
      font-size: 18px;
      margin-top: 15px;
      cursor: pointer;
    }
    .title{
      border: none;
      background: none;
      outline: none;
      font-size: 17px;
      font-weight: 600;
      color: #333;
      margin-bottom: 15px;
    }
    .type-input{
      padding: 20px;
      border-bottom: 1px solid #eee;
      .val{
        height: 40px;
        width: 300px;
        margin-bottom: 15px;
      }
      .el-icon-delete-1{
        margin-top: 0px;
        margin-left: 10px;
      }
      .MY-radio{
        width: 15px;
        height: 15px;
        border-radius: 15px;
        border: 1px solid #999;
        margin-right: 5px;
      }
      .MY-checkbox{
        width: 15px;
        height: 15px;
        border-radius: 3px;
        border: 1px solid #999;
        margin-right: 5px;
      }
      .MY-image{
        width: 300px;
        height: 150px;
        background-color: #eee;
        margin-bottom: 15px;
        i{
          font-size: 40px;
          color: #999;
        }
      }
      .optionInput{
        border: none;
        background: none;
        outline: none;
        color: #333;
      }
    }
  }
</style>